module.exports = __webpack_public_path__ + "static/media/ehsan.948e2fa8.png";